import React from 'react';
import { connect } from 'react-redux';
import CircleLoad from '../../Loader/Circle';
import MailIcon from '../MailIcon';
import config from '../../../config';

const Resent = ({ user, loading }) => {
  return (
    <div className="wf-account__card thank-you">
      {loading ? <CircleLoad /> : <MailIcon />}

      <h3 className="my-4 font-weight-bold text-center">
        Resend Verification Email
      </h3>

      <b>{loading ? (
        'A new confirmation email is being sent, please wait.'
      ) : (
        user && user.success === true ? (
          'Email sent! (Please check your spam folder) Just follow the link provided in the email to complete your registration.  If you’re still facing problems, click the button below to contact us.'
        ) : user && user.reason
      )}</b>
      <button
        className="wf-submit smaller my-4">
        <a
          href={`${config.WordPressURL}help/`}
          target="_blank"
          rel="noreferrer">
          Contact Us
        </a>
      </button>
    </div >
  );
};

const mapStateToProps = (state) => ({
  user: state.user.user,
  loading: state.user.loading,
})

export default connect(mapStateToProps)(Resent);
